export default {"src":"/_next/static/media/LSPD.28877933.svg","height":18,"width":18};